// 1.Create APP
import { createApp } from "vue";
import App from "./App.vue";
const app = createApp(App);

// 2.Modules
import router from "./router/index";
app.use(router);

import store from "./store/index";
app.use(store);

import LoadScript from "vue-plugin-load-script";
app.use(LoadScript);

// 3.Components
import "@arco-design/web-vue/dist/arco.css";
import ElementPlus from "element-plus";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import "element-plus/dist/index.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
app.use(ElementPlus, {
    locale: zhCn,
});
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
}

import FoldBlock from "@/components/common/fold-block.vue";
app.component(FoldBlock.name, FoldBlock);

import FilterWrapper from "@/components/widget/filter_wrapper.vue";
app.component(FilterWrapper.name, FilterWrapper);

import SlidingTabs from "@/components/widget/sliding_tabs.vue";
app.component(SlidingTabs.name, SlidingTabs);

import WidgetTip from "@/components/widget/tip.vue";
app.component(WidgetTip.name, WidgetTip);

import publishHeader from "@/components/publish/publish_header.vue";
app.component(publishHeader.name, publishHeader);

import CommonAvatar from "@/components/common/avatar.vue";
app.component(CommonAvatar.name, CommonAvatar);

import svgIcon from "@/utils/svgIcon";
app.use(svgIcon);

import deviceDirective from "./directives/device/index";

app.directive("device", deviceDirective);

import RxTime from "@2kog/pkg-common/utils/rx-time";
app.config.globalProperties.$RxTime = new RxTime();

// 4.Mount DOM
app.mount("#app");
